import { ICommonIconProps } from './types';

/**
 * -----------------------------------------------------------------------------
 * Renders a shipment package/parcel with an `x-mark` to mean that it's not been
 * delivered.
 */
export function PackageUndeliveredIcon({ className }: ICommonIconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <g id="package-undelivered-icon">
        <path d="M5 16h2m6 3H4c-1.1 0-2-.9-2-2V7.57c0-.27.06-.54.16-.79l1.1-2.57C3.57 3.48 4.3 3 5.1 3h9.8c.8 0 1.52.48 1.84 1.21l1.1 2.57c.11.25.16.52.16.79v3.53M10 3v4.44m7.99 0H2" />

        <path d="M20.54 12.46a5.003 5.003 0 0 1 0 7.07 5.003 5.003 0 0 1-7.07 0c-1.95-1.95-1.95-5.12 0-7.07s5.11-1.95 7.07 0m-5.29 1.79 3.5 3.5m-3.5 0 3.5-3.5" />
      </g>
    </svg>
  );
}
